/** Adopted from: https://crsten.github.io/datepickk/
 *
 * Add a Calendar picker + integrate with wp-json / ACF API to display events
 *
 * @author Matt Haynes <matthew.haynes@joipolloi.com>
 * @package The University of Sheffield - Performance Venues
*/

import getParameterByName from './getParamByName';

const CalendarDatepickk = async () => {
    const calendarContainer = document.getElementById('calendarContainer');
    if (!calendarContainer) return;

    // Initialise the Datepicker
    // eslint-disable-next-line no-undef
    const datepicker = new Datepickk(); // Defined in its own file before this is instanced
    const clearButton = document.getElementById('clear');

    // Configure Datepicker: further options https://crsten.github.io/datepickk/
    datepicker.startDate = localStorage.getItem('from_date') ? new Date(localStorage.getItem('from_date')) : new Date(); // Calendar will start at either the selected date, or today's date if none selected
    datepicker.container = document.querySelector('#datePicker');
    datepicker.maxSelections = 1;
    datepicker.inline = true;
    datepicker.weekStart = 1; // Week starts at monday
    datepicker.show();

    // Fetch events from WordPress REST API
    const url = '/wp-json/wp/v2/event?per_page=100';
    const response = await fetch(url);
    const eventArray = await response.json();

    // Create array of items based on API response with events to highlight
    const toHighlight = [];
    eventArray.forEach(event => {
        const eventDate = Date.parse(event.acf.date);
        toHighlight.push({
            start: new Date(eventDate),
            end: new Date(eventDate),
        });
    });

    datepicker.highlight = {
        dates: [...toHighlight],
        backgroundColor: '#1C9CD9',
        color: '#000000',
    };

    // On page load make sure that the filter is consistent
    const fromDateField = document.getElementById('fromDate');
    datepicker.selectDate(new Date(localStorage.getItem('from_date')));
    const fromDateParam = getParameterByName('from_date');
    if (fromDateParam) fromDateField.setAttribute('value', fromDateParam);

    // Set correct value to pass to future API calls in functions.php
    // eslint-disable-next-line func-names
    datepicker.onSelect = function (checked) {
        if (checked && datepicker.selectedDates[0]) {
            const YMD = new Date(this.toLocaleDateString('en-US')).toISOString().slice(0, 10);
            localStorage.setItem('from_date', YMD);
            fromDateField.setAttribute('value', YMD);
        } else fromDateField.setAttribute('value', '');
    };

    clearButton.addEventListener('click', () => {
        datepicker.unselectAll();
    }, false);
};

export default CalendarDatepickk;
